/**
 * Business-error model for the Reset Password form.
 *
 * Discriminated union: the generic `network` / `api` transport failures (from
 * the app-wide `@/utils/infra-error` classifier) plus the form-specific
 * `validation` variant (field-level messages produced by `validateDraft`).
 *
 * Unlike the Forgot Password flow, the server message IS surfaced to the user (e.g.
 * "Reset link expired"); the caller already holds a one-time token, so there is
 * no account information left to enumerate.
 */
import { classifyInfraError, type InfraFailure } from '@/utils/infra-error';

export type ResetPasswordError =
  | InfraFailure
  | { kind: 'validation'; fields: Record<string, string> };

/**
 * Map an infrastructure error into a domain `ResetPasswordError`. Only ever
 * yields a `network` / `api` failure; `validation` errors are produced directly
 * by the feature's `validateDraft`.
 */
export function toResetPasswordError(e: unknown): ResetPasswordError {
  return classifyInfraError(e, 'An error occurred.');
}
